export default function UserList({ users, onDelete, onUpdate }) {
    if (users.length === 0) {
        return <p>🚫 No users found</p>;
    }

    return (
        <div className="space-y-3">
            {users.map((user) => {
                const { id, name } = user;
                return (
                    <div
                        key={id}
                        className="flex justify-between items-center bg-gray-50 p-3 rounded dark:bg-gray-900 dark:text-white"
                    >
                        <span>{name}</span>
                        <div className="flex gap-4">
                            <button
                                onClick={() => {
                                    const newName = prompt("New name:");
                                    if (!newName) return;
                                    onUpdate(id, newName);
                                }}
                                className="bg-yellow-400 hover:bg-yellow-500 text-white px-2 rounded"
                            >
                                Edit
                            </button>
                            <button
                                onClick={() => onDelete(id)}
                                className="bg-red-500 hover:bg-red-600 text-white px-2 rounded"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
